module.exports = __webpack_public_path__ + "img/e5f29f45b2fab8c3477348a9e0cb5f82.svg";